/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { TAB_TYPES, DEFAULT_SETTING, BUILT_IN_TABS, TAB_VARIANTS } from "../../../utility/constants";

/**
 * Handles sorting, filtering, and merging default tab configuration
 * @param {Object} existingLayoutConfiguration
 */
export const initializeLayoutConfiguration = (existingLayoutConfiguration) => {
	let layoutConfig = existingLayoutConfiguration.tabs
		? existingLayoutConfiguration
		: { tabs: DEFAULT_SETTING.tabs.map((t) => ({ ...BUILT_IN_TABS[t] })) };

	layoutConfig.tabs = layoutConfig.tabs.filter((t) => !t.hidden);

	layoutConfig.tabs.sort((a, b) => {
		if (a.sortOrder === -1) return 1;
		if (b.sortOrder === -1) return -1;
		if (a.sortOrder < b.sortOrder) return -1;
		if (a.sortOrder > b.sortOrder) return 1;
		if (a.displayName < b.displayName) return -1;
		if (a.displayName > b.displayName) return 1;
		return 0;
	});

	const enabledTabCategories = getEnabledTabAttributeCategories(layoutConfig);
	return {
		...layoutConfig,
		wisdomEnabled: existingLayoutConfiguration.wisdomEnabled,
		customerProfilesEnabled: existingLayoutConfiguration.customerProfilesEnabled,
		enabledTabCategories,
		staticTabs: !(layoutConfig.tabs.find((t) => t.variant === TAB_VARIANTS.static) === undefined),
	};
};

/**
 * List of tab categories based on attribute prefixes,
 * used for contact attribute sorting and grouping
 * @param {Object} layoutConfiguration
 */
const getEnabledTabAttributeCategories = (layoutConfiguration) =>
	layoutConfiguration.tabs
		.filter((x) => !x.hidden && x.type === TAB_TYPES.attribute && x.config?.attributePrefix)
		.map((x) => x.config.attributePrefix);
